import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppointmentBookingSource, AppointmentStatus, AppointmentType, CustomerType, IAddress, ISalesAppointment, IServiceAppointment, TransportationType } from '@signal/asp-data-commons';
import * as fromSettingSelector from '../../../../store/settings/settings.selectors';
import * as fromServiceActions from '../../../../store/service-appointment/service-appointment.actions';
import * as fromSalesActions from '../../../../store/sales-appointment/sales-appointment.actions';
import { DateTime, Duration } from 'luxon';
import { SettingsState } from 'src/app/modules/store/settings/settings.reducer';
import * as fromServiceSelectors from '../../../../store/service-appointment/service-appointment.selectors';
import * as fromSalesSelectors from '../../../../store/sales-appointment/sales-appointment.selectors';
import * as fromPartsSelectors from '../../../../store/parts-appointment/parts-appointment.selectors';
import * as util from '../../../../shared/services/util.service';
import { Observable ,Subscription} from 'rxjs';
import { Settings } from '../../../models/settings.model';
import { ServiceAppointmentState } from 'src/app/modules/store/service-appointment/service-appointment.reducer';
import { switchMap } from 'rxjs/operators';
import { AppointmentFormService } from 'src/app/modules/bdc/service-appointment/appointment-form.service';
import { AppointmentService } from '../../../services/appointment.service';
import { countryCd, GLOBAL_CONSTANT } from '../../../../shared/services/util.service';
import { AlertService } from '../../../services/alert.service';
import { IAvail, SalesAppointmentState } from 'src/app/modules/store/sales-appointment/sales-appointment.reducer';
import * as fromSalesAdapter from 'src/app/modules/store/sales-appointment/sales-appointment.adapter';
import { PartsAppointmentState } from 'src/app/modules/store/parts-appointment/parts-appointment.reducer';
import * as fromPartsActions from 'src/app/modules/store/parts-appointment/parts-appointment.actions';
import * as fromPartsAdapter from 'src/app/modules/store/parts-appointment/parts-appointment.adapter';
import { DealerState } from '../../../../store/dealer/dealer.reducer';
import { selectDealerAddressLong } from '../../../../store/dealer/dealer.selectors';
import {TranslateService} from '@ngx-translate/core';
import { AppointmentTimeComponent } from './appointment-time/appointment-time.component';
import { VehicleService } from '../../../services/vehicle.service';
import { AvailabilityService } from '../../../services/availability.service';
import { IPartsVehicle } from '@signal/asp-data-commons/lib/interfaces/appointment';

export declare type IAllAppointment = IServiceAppointment & ISalesAppointment;

export interface NewIServiceAppointment extends IAllAppointment {
   department: string;
   allInventoryVehicles: any[];
}

@Component({
    selector: 'app-appointment-summary-dialog',
    templateUrl: './appointment-summary-dialog.component.html',
    styleUrls: ['./appointment-summary-dialog.component.scss']
})
export class AppointmentSummaryDialogComponent implements OnInit, OnDestroy {
    title = "";
    time;
     private subscriptions: Subscription[] = [];
    summarydetails: any[] = [];
    isSubmitting: boolean = false;
    allTransportation:any;
    transportSelected: string;
    dealerSettings$: Observable<Settings>;
    isCrmIntegrated:boolean;
    isDmsIntegrated:boolean;
    tooltip = {
        transport: 'serviceSchedule.toChooseRemoteTransportTypeUseTheModifyAppointmentLink',
        sync_Error: '',
        resync_text: 'serviceSchedule.resyncAppointment'
    }
    dealerAddress:IAddress ;

    dateFormat : string = 'yyyy-MM-dd';
    checklistDuration:  { min: number; };
    validTransport;
    sscRecallCodes: string[] = [];
    isCancelledApt=false;

    @ViewChild(AppointmentTimeComponent, { static: false }) appointmentTimeComponent: AppointmentTimeComponent;
    isServiceAvailabilityLoading = true;
    isSalesAvailabilityloading = true;
    trasportationChange = false;
    isApptCompleted=false;

    constructor(   private readonly alertService: AlertService,   private readonly appointmentService: AppointmentService,
        public readonly appointmentFormService: AppointmentFormService, 
        private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
        private readonly salesAppointmentState: Store<SalesAppointmentState> ,
        private readonly partsAppointmentState: Store<PartsAppointmentState>,
          private readonly settingsState: Store<SettingsState>, 
         public readonly dialogRef: MatDialogRef<AppointmentSummaryDialogComponent>,
         @Inject(MAT_DIALOG_DATA) public data: NewIServiceAppointment, private readonly router: Router,
        private readonly dealerState: Store<DealerState>,
        private readonly translate: TranslateService,
        private readonly cdref: ChangeDetectorRef,
        public readonly vehicleService: VehicleService,
        private availabilityService: AvailabilityService) {}

    isValidSummaryFormEnable() {
        return this.appointmentTimeComponent?.step?.valid && (this.trasportationChange || !this.appointmentTimeComponent.step.pristine) && (!this.isServiceAvailabilityLoading || !this.isSalesAvailabilityloading);
    }

    isValidTransport(){
        if (this.data?.appointmentType === AppointmentType.PARTS) {
            return true;
        }
        if (!this.allTransportation) {
            return false;
        }
        const valid = this.allTransportation.filter(t => t.isActive).map(t => t.id)
        return valid.includes(this.transportSelected)
    }
    
    getDeletePendingStatus(): boolean {
        return fromSalesAdapter.getDeletePendingForTestdrive(this.data, this.data.allInventoryVehicles);
    }

    ngOnInit(): void {
        this.isCrmIntegrated = util.isAspCrmIntegrationEnabled;
        this.isDmsIntegrated = util.isAspDmsIntegrationEnabled;
        this.title = util.getCustomerDisplayName(this.data.customer);
        this.transportSelected = this.data.transportationTypeCode || TransportationType.WAITER;
        this.transportSelected = this.data?.transportation?.id;
        this.dealerSettings$ = this.settingsState.select(fromSettingSelector.selectSettings);
        this.availabilityService.data$.subscribe(data => {
            if(data.changed) {
                this.transportSelected = data.data || TransportationType.WAITER;
                this.trasportationChange = true;
            }
        });
        this.dealerSettings$.subscribe(data => {
            this.allTransportation = data?.transport?.transportOptions
            this.validTransport = this.allTransportation?.filter(t => t.isActive);
        })
        if(this.data.appointmentType === AppointmentType.SERVICE){
            this.setUpServiceStore();
        }else if(this.data.appointmentType === AppointmentType.TEST_DRIVE || 
            this.data.appointmentType === AppointmentType.DELIVERY ||
            this.data.appointmentType === AppointmentType.LEARNING ||
            this.data.appointmentType === AppointmentType.VEHICLE_INQUIRY) {
            this.setUpSalesStore();
        } else if (this.data.appointmentType === AppointmentType.PARTS) {
            this.setUpPartsStore();
        }
        this.isApptCompleted = this.data.appointmentStatus === AppointmentStatus.COMPLETED;
        this.isCancelledApt = this.data.appointmentStatus === AppointmentStatus.CANCELED;
        this.getdata();
    }

    setUpServiceStore(){
        this.serviceAppointmentState.dispatch(new fromServiceActions.LoadAvailabilityOptions());
        this.serviceAppointmentState.dispatch(
            new fromServiceActions.EditServiceAppointment({ appointmentId: this.data.appointmentId, 
                email: this.data.emailAddress, appointment: this.data }));
        const date = DateTime.fromISO(this.data.appointmentStartDate)
        .startOf('month')
        .toFormat(this.dateFormat);
        const advisorId = this.data.advisorId;
        const transport = this.transportSelected;
        const vin = this.data.vehicle.vin || '';
        if(vin) {
            this.sscDetails(vin);
        }
        this.serviceAppointmentState.dispatch(new fromServiceActions.LoadAvailability({ date, advisorId, transport, vin: vin, appointmentId: this.data.appointmentId }))
       this.subscriptions.push(this.settingsState.select(fromSettingSelector.transportOptRemote).subscribe(res =>{
            if(res && res.cost){
              this.appointmentFormService.setCostAndFlatRateHrsForCompEligibleRental(res.cost,res.flatRateHours);
            }
          })
       )
          this.subscriptions.push( this.serviceAppointmentState.select(fromServiceSelectors.selectAvailabilityLoading).subscribe(value=>{ 
            this.isServiceAvailabilityLoading = value;
          }));
    }

    setUpSalesStore(){
        this.salesAppointmentState.dispatch(new fromSalesActions.LoadAvailabilityOptions({appointmentType: this.data.appointmentType}));
        this.salesAppointmentState.dispatch(new fromSalesActions.GetEditData
            ({appointmentType: this.data.appointmentType, appointmentId: this.data.appointmentId }));
        const date = DateTime.fromISO(this.data.appointmentStartDate)
        .startOf('month')
        .toFormat(this.dateFormat);
        const advisorId = this.data.advisorId;
        const transport = this.transportSelected;
        /* *availability loads differently for testdrive appts, vehicles with a vin or without a vin */
        if (this.data.vehicle?.vin && AppointmentType.TEST_DRIVE === this.data.appointmentType) {
            this.salesAppointmentState.dispatch(new fromSalesActions.LoadAvailability({ selectDateAndSlot:true, 
                date, advisorId, transport, vin: this.data.vehicle?.vin, appointmentType: AppointmentType.TEST_DRIVE,appointmentId:this.data.appointmentId ? this.data.appointmentId : '' }))
        } else {
            const payload = {selectDateAndSlot:true, date, advisorId, transport,  appointmentType:this.data.appointmentType,appointmentId:this.data.appointmentId ? this.data.appointmentId : ''};
             this.salesAppointmentState.dispatch(new fromSalesActions.LoadAvailability(payload))
        }
        this.subscriptions.push(this.dealerState.select(selectDealerAddressLong).subscribe(address=>{
            this.dealerAddress = {...address, country: countryCd}
        }))

        this.subscriptions.push( this.salesAppointmentState.select(fromSalesSelectors.getAvailabilityLoading).subscribe(value=>{
            this.isSalesAvailabilityloading = value;
        }));
    }

    setUpPartsStore() {
        this.partsAppointmentState.dispatch(new fromPartsActions.LoadAvailabilityOptions({ appointmentType: this.data.appointmentType }));
        this.partsAppointmentState.dispatch(new fromPartsActions.GetEditData
            ({ appointmentType: this.data.appointmentType, appointmentId: this.data.appointmentId }));
        const date = DateTime.fromISO(this.data.appointmentStartDate)
            .startOf('month')
            .toFormat(this.dateFormat);
        const advisorId = this.data.advisorId;
        const transport = this.transportSelected;
        const payload = { selectDateAndSlot: true, date, advisorId, transport, appointmentType: this.data.appointmentType, appointmentId: this.data.appointmentId ? this.data.appointmentId : '' };
        this.partsAppointmentState.dispatch(new fromPartsActions.LoadAvailability(payload));

        this.subscriptions.push(this.dealerState.select(selectDealerAddressLong).subscribe(address => {
            this.dealerAddress = { ...address, country: countryCd }
        }))

        this.subscriptions.push(this.partsAppointmentState.select(fromPartsSelectors.getAvailabilityLoading).subscribe(value => {
            this.isSalesAvailabilityloading = value;
        }));
    }

    sscDetails(vin) {
        this.subscriptions.push(
            this.vehicleService.fetchSSCdetailsFromServer(vin).subscribe(data => {
            if (data.status.code === 200) {
                const specialServiceCampaigns = data?.data?.specialServiceCampaigns;
                this.sscRecallCodes = (specialServiceCampaigns?.length>0) ? specialServiceCampaigns.map(campaign => `${campaign.sscCode} : ${campaign.sscDescription +' ('+campaign.remedyAvailable+')'}`) : [];
                
                const index =  this.summarydetails.findIndex(data=> data.key === 'serviceSchedule.serviceDetails');
                if(this.sscRecallCodes.length>0) {
                    if (index !== -1) {
                        this.summarydetails.splice(index, 0, {'key': 'serviceSchedule.specialServiceCampaignOpenRecall', value: this.sscRecallCodes});
                    }
                }
            } else {
                this.sscRecallCodes = [];
            }
            }, _err => {
                this.sscRecallCodes = [];
            })
        )
    }
    
    titleCase(str) {
      return str.toLowerCase().split(' ').map(function(word) {
        return word.replace(word[0], word[0].toUpperCase());
      }).join(' ');
    }

    getAppointmentCreatedBy(data){
        if (data.appointmentBookingSource === AppointmentBookingSource.ONEAPP || data.appointmentBookingSource === AppointmentBookingSource.ONEAPP_SP) {
            return 'serviceSchedule.oneApp';
        } else if (data.appointmentBookingSource === AppointmentBookingSource.ASP){
            return 'serviceSchedule.asp';
        } else if (data.appointmentBookingSource === "TCNA"){
            return 'serviceSchedule.tcna';
        } else if (data.appointmentBookingSource === "MSTC"){
            return 'serviceSchedule.mstc';
        } else if (data.appointmentCreatedByUserName) {
            return data.appointmentCreatedByUserName;
        } else if (data.appointmentCreatedBy) {
            return data.appointmentCreatedBy;
        } else {
            return '';
        }
    }

    getdata() {
        this.time = DateTime.fromISO(this.data.appointmentStartDate).toFormat('MMM dd') + ' at ' + this.data.timeSlotId;
        this.time = this.data.appointmentStatus + ` - ${this.time}`;
        
        let vehicle = util.getMakeModelYearText(this.data?.vehicle);
        if (this.data?.vehicle?.vin) {
            vehicle += (vehicle ? " - " + this.data.vehicle.vin : this.data.vehicle.vin);
        }
        if(this.data.appointmentType===AppointmentType.VEHICLE_INQUIRY)
        {
            if(!this.data?.vehiclesOfInterest?.length && !this.data?.vehicleType)
            {
                vehicle='vehicleInquiry.notSpecified';
            }
            else{
                vehicle =util.getVehicleTypeTraslation(this.data?.vehicleType,this.translate);
            }
        }
        if (this.data.appointmentType === AppointmentType.PARTS) {
            const hasVehicleData = !!vehicle?.trim() || !!this.data?.vehicle?.vin?.trim();
            if (!hasVehicleData) {
                vehicle = 'NA';
            }
        }
        const vehicleList = util.getVehicleDisplayTextForEnquiryAppt(this.data?.vehiclesOfInterest,this.translate);
        this.summarydetails.push({
            'key':this.data.appointmentType === AppointmentType.VEHICLE_INQUIRY ? 'vehicleInquiry.vehiclesOfInterest' : 'testDrive.vehicle',
            'value': vehicle,
            'data':vehicleList
        }, {
            'key': 'serviceSchedule.appointmentSyncStatus',
            'value': this.data.syncStatus
        },{
            'key': 'serviceSchedule.appointmentCreatedBy',
            'value': this.getAppointmentCreatedBy(this.data)
        });
        if(this.data.syncStatus === 'SYNC_FAILURE'){
            this.tooltip.sync_Error = this.data.syncError;
        }
        
        //servicerequests.push({ 'key': "Service Advisor", 'value': this.data.advisor.displayName });
        if(this.data.appointmentType === AppointmentType.SERVICE){
            const servicerequests = this.getServicesCostAndTime();
            this.summarydetails.push({ 'key': 'serviceSchedule.serviceDetails', 'value': servicerequests });
            if (this.data?.appointmentComments) {
                this.summarydetails.push({
                    'key': 'service.additionalCustomerComments',
                    'value': this.data.appointmentComments
                });
            }

            if (this.data?.dealershipApptComments) {
                this.pushProtectionProductDetails();
            }
        } else if (this.data.appointmentType === AppointmentType.TEST_DRIVE || this.data.appointmentType === AppointmentType.DELIVERY || this.data.appointmentType === AppointmentType.LEARNING || this.data.appointmentType === AppointmentType.VEHICLE_INQUIRY || this.data.appointmentType === AppointmentType.PARTS) {
            this.summarydetails.push({ 'key': 'service.location', 'value': this.data.transportation?.category || this.data.transportationTypeCode });
            if (this.data.appointmentType === AppointmentType.PARTS) {
                const partsVehicle = this.data.vehicle as IPartsVehicle;
                this.summarydetails.push({ 'key': 'serviceSchedule.appointmentType', 'value': this.translate.instant('navigation.partsPickUp') });
                this.summarydetails.push({
                    'key': 'parts.orderRef',
                    'value': partsVehicle?.orderRefNumber || 'NA'
                });
                this.summarydetails.push({
                    'key': 'parts.dealerOrder',
                    'value': partsVehicle?.dealerOrderNumber || 'NA'
                });
            } else {
                this.summarydetails.push({ 'key': 'serviceSchedule.appointmentType', 'value': this.data.appointmentType });
            }
            if (this.data?.appointmentComments) {
                const apptComment = this.data?.appointmentComments ? this.getComment(this.data?.appointmentComments, 'Comments-From-Dealer') : '';
                if (apptComment) {
                    this.summarydetails.push({
                        'key': 'delivery.commentsFromDealer',
                        'value': apptComment
                    });
                }

                const dealerInternalComment = this.data?.appointmentComments ? this.getComment(this.data?.appointmentComments, 'Dealer-Internal-Comments') : '';
                if (dealerInternalComment) {
                    this.summarydetails.push({
                        'key': 'delivery.internalDealerComments',
                        'value': dealerInternalComment
                    });
                }

                const additionalComments = this.data?.appointmentComments ? this.getComment(this.data?.appointmentComments, 'Customer-Additional-Comments') : '';
                if (additionalComments) {
                    this.summarydetails.push({
                        'key': 'delivery.customerComments',
                        'value': additionalComments
                    });
                }

            }

            const tradeInSummary = util.getTradeInVehicleSummaryText((this.data as any).tradeInVehicle);
            if (tradeInSummary) {
                this.summarydetails.push({
                    'key': 'testDrive.tradeIn',
                    'value': tradeInSummary
                });
            }
        }

    }

    getServicesCostAndTime() {
        const servicerequests = [];
        let estimatedCost = 0;
        if(this.data.serviceRequests && this.data.serviceRequests.length) {
        for (const servicerequest of this.data.serviceRequests) {
            let key='';
            if (servicerequest?.details?.displayName) {
                key = servicerequest.details.displayName;
            } else if (servicerequest?.details?.description) {
                key = servicerequest.details.description;
            }
            else {
                key = servicerequest?.details?.dmsDescription;
            }
            let value = '';
            if (servicerequest?.details?.recommended?.isCoveredByToyotaCare){
                value = this.data.dealerCode.startsWith('6') ? "service.lexusComplimentaryMaintenance" :
                    (util.countryCd === 'MEX' ? "service.toyotaComplimentaryMaintenance" : "service.coveredByToyotaCare");
            }
            else if(this.data.appointmentCreatedBy === 'DMS' || (servicerequest?.details?.pricing?.show)){
                const priceAndEstimatedCost = this.getOpcodePriceAndEstimatedCost(servicerequest);
                value = priceAndEstimatedCost.value;
                estimatedCost += priceAndEstimatedCost.estimatedCost;
            }
            else {
                value = "service.askAdvisor";
            }
            servicerequests.push({ 'key': key, 'value': value })
        }
    }

        servicerequests.push({
            'key': `<b>${this.translate.instant('service.estimatedCost')}</b>`,
            'value': `${util.toUsDollar(this.data.appointmentCreatedBy === 'DMS' ? (this.data.totalPrice || 0) : estimatedCost)}`
        });

        const estimatedTime: number = (this.data.totalLaborHours || 0) * 60;
        const luxonSlotTime = Duration.fromObject({ minutes: estimatedTime }).toFormat('hh:mm').split(":");
        servicerequests.push({
            'key': `<b>${this.translate.instant('service.estimatedTime')}</b>`,
            'value': luxonSlotTime[0] + 'hrs ' + luxonSlotTime[1] + 'mins'
        });

        return servicerequests;
    }

    getOpcodePriceAndEstimatedCost(servicerequest) {
        let value = '', estimatedCost = 0;
        value +=  util.getOpcodeFinalPricing(servicerequest.details);
        estimatedCost = servicerequest.details.pricing.final ? this.getFinalPriceValue(servicerequest.details.pricing?.final) : 0;
        return { value, estimatedCost };
    }

    getFinalPriceValue(price) {
        let resPrice = price;
        if(typeof resPrice === 'string') {
            resPrice = parseFloat(price);
        }
        return resPrice;
    }

    pushProtectionProductDetails() {
        const comments = this.data?.dealershipApptComments?.split(':');
            let comment='';
            if(this.data?.dealershipApptComments?.includes(': Eligible for Protection Products - YES')){
                comment+=`Eligible for Protection Products - YES`;
            }
            if(comments?.length > 0){
                comments.forEach(dealershipComment=>{
                    if(dealershipComment?.includes(`Valid Protection Plans`)){
                        comment += comment ? `<br>${dealershipComment?.trim()}` : dealershipComment?.trim();
                    }
                })
            }
            if(comment){
                this.summarydetails.push({ 'key': 'service.protectionProductsDetails', 'value': comment})
            }
    }

    getComment(data, field) {
        let returnComment = '';
        data.split(':::').forEach(comment=> {
          if(comment.includes(field)) {
            returnComment = comment.replace(`${field} - `, '').trim();
          }
        })
        return returnComment;
      }

    getLength(item) {
        if (item.value && item.value.replace(/^\D+/g, '').length!=0){
            return item.value.replace(/^\D+/g, '').length
        }
        if (item.value && item.value.replace(" ",'').match(/^[A-Za-z]+$/)){
            return item.value.length;
        }
    }

    appointmentAction(actionType: string){
        if(actionType === 'reschedule'){
            this.dialogRef.close();
            const path = this.data.appointmentType === AppointmentType.TEST_DRIVE ? 'testdrive' : 'delivery';
            if (this.data.appointmentType === AppointmentType.TEST_DRIVE || this.data.appointmentType === AppointmentType.DELIVERY) {
            this.serviceAppointmentState.dispatch(new fromSalesActions.ResetSalesAppointmentState());
                this.router.navigate([`asp/bdc/${path}`], {
                  queryParams: {
                    id: this.data.appointmentId,
                    email: this.data.emailAddress
                  }
                });
              }
            else if (this.data.appointmentType === AppointmentType.LEARNING){
                this.serviceAppointmentState.dispatch(new fromSalesActions.ResetSalesAppointmentState());
                this.router.navigate([`asp/bdc/tech-appointment`], {
                  queryParams: {
                    id: this.data.appointmentId,
                    email: this.data.emailAddress
                  }
                });
            }
            else if (this.data.appointmentType === AppointmentType.VEHICLE_INQUIRY){
                this.serviceAppointmentState.dispatch(new fromSalesActions.ResetSalesAppointmentState());
                this.router.navigate([`asp/bdc/vehicleinquiry`], {
                  queryParams: {
                    id: this.data.appointmentId,
                    email: this.data.emailAddress
                  }
                });
            }
            else if (this.data.appointmentType === AppointmentType.PARTS) {
                this.partsAppointmentState.dispatch(new fromPartsActions.ResetSalesAppointmentState());
                this.router.navigate([`asp/bdc/parts`], {
                    queryParams: {
                        id: this.data.appointmentId,
                        email: this.data.emailAddress
                    }
                });
            }
            else if(this.data.appointmentType === AppointmentType.SERVICE){
                this.serviceAppointmentState.dispatch(new fromServiceActions.ResetServiceAppointmentState());
                this.router.navigate(['/asp/bdc/service'],{queryParams:{id:this.data.appointmentId, navigateTo: 'service-dashboard'}});
            }
        }else if(actionType === 'cancel'){
            this.dialogRef.close('cancel');
        }else{
            this.dialogRef.close('confirm');
        }
    }

    editAppointment(type: string){
        this.isSubmitting = type === 'edit' ? true : false;
        if(this.data.appointmentType === AppointmentType.SERVICE){
            const serviceAppointmentState$ = this.serviceAppointmentState.select(fromServiceSelectors.selectServiceAppointmentFeature);
            const updateAppointment$ = serviceAppointmentState$.pipe(
                switchMap((serviceAppointmentFeature: ServiceAppointmentState) =>
                this.appointmentService.update(this.appointmentFormService.getMainFormDataAsUpdateReq(serviceAppointmentFeature))));

                this.subscriptions.push(updateAppointment$.subscribe(_t => {
                    this.isSubmitting = false;
                    if(type === 'resync'){
                    this.alertService.showAlert('otherTexts.re-syncInitiated', '', '', 5000, false);
                    }
                    this.dialogRef.close();
                }, _error => {
                    this.isSubmitting = false;
                    this.alertService.showAlert(util.getAlertErrorMessage(_error, GLOBAL_CONSTANT.errorMessage));
                }));
        }
        else if(this.data.appointmentType === AppointmentType.TEST_DRIVE){
            const payload = {appointmentType : AppointmentType.TEST_DRIVE, summaryDialog: true};
            const salesAppointmentState$ = this.salesAppointmentState.select(fromSalesSelectors.selectSalesAppointmentFeature);
            const updateAppointment$ = salesAppointmentState$.pipe(
                switchMap((salesAppointmentFeature: SalesAppointmentState) =>
                this.appointmentService.update(fromSalesAdapter.updateSalesAppointment(salesAppointmentFeature,payload,'', []))
            ));
            this.subscriptions.push(updateAppointment$.subscribe(_t => {
                this.isSubmitting = false;
                this.dialogRef.close();
            }, error => {
                this.isSubmitting = false;
                this.alertService.showAlert(util.getAlertErrorMessage(error, GLOBAL_CONSTANT.errorMessage));
            }));
        }
        else if(this.data.appointmentType === AppointmentType.DELIVERY){
            const payload = {appointmentType : AppointmentType.DELIVERY}
            const dealerAddress = this.dealerAddress;
            const salesAppointmentState$ = this.salesAppointmentState.select(fromSalesSelectors.selectSalesAppointmentFeature);
            const updateAppointment$ = salesAppointmentState$.pipe(
                switchMap((salesAppointmentFeature: SalesAppointmentState) =>
                this.appointmentService.update(fromSalesAdapter.updateSalesAppointment(salesAppointmentFeature,payload,dealerAddress))
            ));
            this.subscriptions.push(updateAppointment$.subscribe(_t => {
                this.isSubmitting = false;
                this.dialogRef.close();
            }, error => {
                this.isSubmitting = false;
                this.alertService.showAlert(util.getAlertErrorMessage(error, GLOBAL_CONSTANT.errorMessage));
            }));
        }
        else if(this.data.appointmentType === AppointmentType.LEARNING){
            const payload = {appointmentType : AppointmentType.LEARNING}
            const dealerAddress = this.dealerAddress;
            const salesAppointmentState$ = this.salesAppointmentState.select(fromSalesSelectors.selectSalesAppointmentFeature);
            const updateAppointment$ = salesAppointmentState$.pipe(
                switchMap((salesAppointmentFeature: SalesAppointmentState) =>
                this.appointmentService.update(fromSalesAdapter.updateSalesAppointment(salesAppointmentFeature,payload,dealerAddress))
            ));
            this.subscriptions.push( updateAppointment$.subscribe(_t => {
                this.isSubmitting = false;
                this.dialogRef.close();
            }, error => {
                this.isSubmitting = false;
                this.alertService.showAlert(util.getAlertErrorMessage(error, GLOBAL_CONSTANT.errorMessage));
            }));
        }
        else if(this.data.appointmentType === AppointmentType.VEHICLE_INQUIRY){
            const payload = {appointmentType : AppointmentType.VEHICLE_INQUIRY}
            const dealerAddress = this.dealerAddress;
            const salesAppointmentState$ = this.salesAppointmentState.select(fromSalesSelectors.selectSalesAppointmentFeature);
            const updateAppointment$ = salesAppointmentState$.pipe(
                switchMap((salesAppointmentFeature: SalesAppointmentState) =>
                this.appointmentService.update(fromSalesAdapter.updateSalesAppointment(salesAppointmentFeature,payload,dealerAddress))
            ));
            this.subscriptions.push(updateAppointment$.subscribe(_t => {
                this.isSubmitting = false;
                this.dialogRef.close();
            }, error => {
                this.isSubmitting = false;
                this.alertService.showAlert(util.getAlertErrorMessage(error, GLOBAL_CONSTANT.errorMessage));
            }));
        }
        else if (this.data.appointmentType === AppointmentType.PARTS) {
            const payload = { appointmentType: AppointmentType.PARTS }
            const dealerAddress = this.dealerAddress;
            const partsAppointmentState$ = this.partsAppointmentState.select(fromPartsSelectors.selectPartsAppointmentFeature);
            const updateAppointment$ = partsAppointmentState$.pipe(
                switchMap((partsAppointmentFeature: PartsAppointmentState) =>
                    this.appointmentService.update(fromPartsAdapter.updateSalesAppointment(partsAppointmentFeature, payload, dealerAddress))
                ));
            this.subscriptions.push(updateAppointment$.subscribe(_t => {
                this.isSubmitting = false;
                this.dialogRef.close();
            }, error => {
                this.isSubmitting = false;
                this.alertService.showAlert(util.getAlertErrorMessage(error, GLOBAL_CONSTANT.errorMessage));
            }));
        }
    }

    availabilityChange(availability:IAvail){
        if((this.data.appointmentType === AppointmentType.TEST_DRIVE || this.data.appointmentType === AppointmentType.DELIVERY || this.data.appointmentType === AppointmentType.LEARNING || this.data.appointmentType === AppointmentType.VEHICLE_INQUIRY)){
            this.salesAppointmentState.dispatch(new fromSalesActions.UpdateSalesAvailabilityData({value : availability}))
        } else if (this.data.appointmentType === AppointmentType.PARTS) {
            this.partsAppointmentState.dispatch(new fromPartsActions.UpdateSalesAvailabilityData({ value: availability }))
        }
    }

    initiateResync(){
        this.subscriptions.push(this.appointmentService.resyncAppointment(this.data).subscribe(data => {
            if(data){
                this.alertService.showAlert('otherTexts.re-syncInitiated', '', '', 5000, false);
                this.dialogRef.close();
            }
        }, error => {
            this.isSubmitting = false;
            this.alertService.showAlert(util.getAlertErrorMessage(error, GLOBAL_CONSTANT.errorMessage));
        }));
    }

    ngAfterContentChecked() {
        if (!this.cdref['destroyed']) {
            this.cdref.detectChanges();
        }
    }
    

  ngOnDestroy(): void {
      this.cdref.detach();
      this.availabilityService.resetData();
      this.subscriptions.forEach(sub => sub.unsubscribe());
  }



  parsedText(text) {
    const dom = new DOMParser().parseFromString(
    '<!doctype html><body>' + text,
    'text/html');
    const decodedString = dom.body.textContent;
    return decodedString;
  }

  opCodePricingTranslation(text){
    if(text){
      text = text.replace('Starts at', this.translate.instant('opcodeServiceManagement.startsAt'));
      text = text.replace('Ranges from', this.translate.instant('opcodeServiceManagement.rangesFrom'));
    }
    return text;
  }

    isMyKarmaAppointment() {
        return this.data?.appointmentBookingSource === AppointmentBookingSource.MYKARMA;
    }

    isNotEnableChange() {
        if (this.isMyKarmaAppointment()) {
            return true;
        }

        if (this.data.appointmentType === AppointmentType.SERVICE) {
            return !util.isServiceAccessibleFeatureFlag ? (util.isSpServiceDashboardOverride || false) : false;
        }
        else if (this.isCancelledApt && this.data.appointmentType === AppointmentType.DELIVERY) {
            return true;
        }
        else {
            return false;
        }
    }

  closeWindow() {
        this.dialogRef.close({ action: 'closeWindow' });
   }
}
